import css from './index.less';
import React from 'react';
interface IProps {
    username: string;
    name: string;
}
export class KimUser extends React.Component<IProps, any> {
    public render(): React.ReactElement {
        return <a className={ css.hoverKim }
                  href={ `kim://username?username=${ this.props.username }` }>
            <img
                className={ css.kimImg }
                src={ 'https://cdnfile.corp.kuaishou.com/kc/files/a/QA-SERVEREE-FE-IN/kim.png' }
            />
            <span className={ css.username }>{ this.props.name }</span>
        </a>;
    }
}
